var map = {
	"./bottom-button-1-down.png": "fmr8",
	"./bottom-button-2-down.png": "KWsS",
	"./bottom-button-3-down.png": "dM4t"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "r/Gs";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/report ^\.\/bottom\-button\-.*\-down\.png$
// module id = r/Gs
// module chunks = 1